export const CATALOG = [
  {
    id: "2post",
    cat: "Lifts",
    name: "2-Post Lift",
    fw: 12,
    fh: 16,
    color: "#021828",
    border: "#0090c8",
    capacity: "9K–20K lbs",
    variants: ["9K", "10K", "12K", "15K", "16K", "20K"],
    requirements: ["220V", "Concrete Anchor", "Min 11ft Ceiling"],
    // Bay clearance zone — working/safety footprint around the lift.
    // 13'W x 26'D matches Rotary SPO12RA spec (6.5' each side, 13' fore/aft of center).
    bayFootprint: { width: 13, depth: 26 },
    // ─── 3D rendering fields ────────────────────────────────────
    // modelPath: GLB file in /public/models/ (relative to that folder)
    // height3d: real-world height in feet (SPO12 minimum = 11'8" = 11.67ft)
    // color3d: fallback box color when GLB hasn't loaded yet (matches T.blue)
    modelPath: "rotary-spo12.glb",
    height3d: 11.67,
    color3d: "#3399ff",
  },
  {
    id: "4post",
    cat: "Lifts",
    name: "4-Post Lift",
    fw: 16,
    fh: 24,
    color: "#011220",
    border: "#0090c8",
    capacity: "14K–30K lbs",
    variants: ["14K", "18K", "22K", "30K"],
    requirements: ["220V", "Concrete Anchor", "Min 12ft Ceiling"],
    modelPath: "rotary-4post.glb",
    height3d: 7.58,
    color3d: "#1a1a1c",
  },
  {
   id: "scissor",
   cat: "Lifts",
   name: "Scissor Lift",
   fw: 12,             // catalog footprint — keep as-is for 2D placement
    fh: 22,             // updated to match real RX14 length (was 14)
    color: "#021828",
    border: "#0090c8",
    capacity: "7K–14K lbs",
    variants: ["7K", "10K", "14K"],
    requirements: ["220V", "Concrete Anchor"],
    modelPath: "hunter-rx14.glb",
    height3d: 3.77,      // partially raised position
    modelOffsetX: -1.5,    // shift left so rails center on door
    color3d: "#1a1a1c",
  },
  {
    id: "inground",
    cat: "Lifts",
    name: "In-Ground Lift",
    fw: 10,
    fh: 24,
    color: "#021828",
    border: "#0090c8",
    capacity: "10K–12K lbs",
    variants: ["10K", "12K"],
    requirements: ["220V", "Concrete Anchor", "In-Ground Installation"],
    // Bay clearance zone — same working footprint convention as 2-post.
    // In-grounds need clear side and end access for vehicle entry/exit.
    bayFootprint: { width: 13, depth: 26 },
    modelPath: "inground-lift.glb",
    height3d: 0.53,
    color3d: "#1a1a1c",
  },
  {
    id: "mobile_column",
    cat: "Lifts",
    name: "Mobile Column Lift",
    fw: 4,
    fh: 4,
    color: "#021828",
    border: "#0090c8",
    capacity: "14K–18.8K lbs per column",
    variants: ["14K", "18.8K"],
    requirements: ["Battery Powered", "No Anchoring Required"],
    modelPath: "mobile-column.glb",
    height3d: 8.5,
    color3d: "#1a1a1c",
    modelRotation: 90,
  },
  {
    id: "tc",
    cat: "Tire",
    name: "Tire Changer",
    fw: 6.17,   // 74 × 44 in — Coats Maxx 80E listed footprint, incl. assist arm + bead-breaker swing
    fh: 3.67,
    color: "#0e1e06",
    border: "#3a9010",
    requirements: ["110V", "Air Supply"],
    modelPath: "tire-changer.glb",
    height3d: 5.34,
    color3d: "#1a1a1c",
  },
  {
    id: "bal",
    cat: "Tire",
    name: "Wheel Balancer",
    fw: 4.25,   // 51 × 58 in — Coats RC 450 listed footprint, incl. hood + mounted wheel
    fh: 4.83,
    color: "#081806",
    border: "#288010",
    requirements: ["110V"],
    modelPath: "wheel-balancer.glb",
    height3d: 5.55,
    color3d: "#1a1a1c",
  },
  {
    id: "aln",
    cat: "Tire",
    name: "Wheel Aligner",
    fw: 8.75,   // 105 × 35.5 in — Hunter HawkEye Elite X camera beam width × base depth
    fh: 2.96,
    color: "#1a1000",
    border: "#b06010",
    requirements: ["110V", "Min 24ft Bay Depth"],
    modelPath: "hunter-aligner.glb",
    height3d: 8.5,
    color3d: "#1a1a1c",
  },
  {
    id: "comp",
    cat: "Air",
    name: "Air Compressor",
    fw: 3.17,   // 38 × 26 in — Ingersoll Rand 2475N7.5-V, 80 gal vertical
    fh: 2.17,
    color: "#180a00",
    border: "#c04010",
    requirements: ["220V", "Ventilation"],
  },
  {
    id: "wash",
    cat: "Service",
    name: "Parts Washer",
    fw: 2.5,   // 30 × 21 in — Eastwood 14293 / Shop Fox W1760 20 gal
    fh: 1.75,
    color: "#001018",
    border: "#108060",
    requirements: ["110V", "Drainage"],
  },
  {
    id: "fjack",
    cat: "Service",
    name: "Floor Jack",
    fw: 1.17,   // 14 × 32 in — 3-ton long-chassis service jack, handle upright
    fh: 2.67,
    color: "#100606",
    border: "#802020",
    requirements: [],
  },
  {
    id: "odrain",
    cat: "Service",
    name: "Oil Drain Station",
    fw: 1.83,   // 22 × 46 in — JohnDow JDI-25HDC 25 gal lift drain
    fh: 3.83,
    color: "#0a0618",
    border: "#502880",
    requirements: ["Drainage"],
  },
  {
    id: "toolbox",
    cat: "Storage",
    name: "Tool Cabinet",
    fw: 6,   // 72 × 24 in — 72" roller cabinet (Husky class)
    fh: 2,
    color: "#100e00",
    border: "#907820",
    requirements: [],
    modelPath: "tool-cabinet.glb",
    height3d: 4.0,
    color3d: "#1a1a1c",
  },
  {
  id: "wbench",
  cat: "Storage",
  name: "Workstation",          // Updated name to reflect monitor+tools setup
  fw: 6,                         // Was 12 — corrected to match actual workbench
  fh: 4,
  color: "#0e0a00",
  border: "#706010",
  requirements: [],
  modelPath: "workbench.glb",
  height3d: 6.0,                 // Includes back panel + monitor
  color3d: "#1a1a1c",
},
  {
    id: "obstruction",
    cat: "Structure",
    name: "Obstruction",
    fw: 2,
    fh: 2,
    color: "#1a0a0a",
    border: "#cc3333",
    requirements: [],
    isObstruction: true,
  },
];

// ─── Real-size migration (v4.5) ───────────────────────────────────────
// These items used to have placeholder footprints (e.g. an 8×8 ft
// compressor). Old saved projects carry those sizes on each placed item,
// so on load we update any item still at its OLD default and not resized
// by hand (scale 1×1). Hand-resized items are left exactly as they were.
export const LEGACY_FOOTPRINTS = {
  tc: { fw: 3, fh: 3 },
  bal: { fw: 3, fh: 3 },
  aln: { fw: 8, fh: 3 },
  comp: { fw: 8, fh: 8 },
  wash: { fw: 8, fh: 8 },
  fjack: { fw: 4, fh: 8 },
  odrain: { fw: 4, fh: 8 },
  toolbox: { fw: 8, fh: 4 },
};

export function migrateEquipmentSizes(placed) {
  return (placed || []).map((item) => {
    const old = LEGACY_FOOTPRINTS[item.id];
    if (!old || item.fw !== old.fw || item.fh !== old.fh) return item;
    if ((item.scaleX ?? 1) !== 1 || (item.scaleY ?? 1) !== 1) return item;   // resized by hand
    const cat = CATALOG.find((c) => c.id === item.id);
    return cat ? { ...item, fw: cat.fw, fh: cat.fh } : item;
  });
}

export const CATS = [...new Set(CATALOG.map((e) => e.cat))];

export const DEFAULT_DRAIN = { w: 2, h: 2 };

export const TEMPLATES = [
  {
    id: "two-bay-tire",
    name: "2-Bay Tire Shop",
    icon: "⭕",
    description:
      "Tire changer, balancer, and storage for a focused tire operation.",
    shop: { w: 40, h: 30, unit: "ft" },
    doors: [
      { id: 1, wall: "S", pos: 0.3, type: "overhead", width: 10 },
      { id: 2, wall: "S", pos: 0.7, type: "overhead", width: 10 },
      { id: 3, wall: "N", pos: 0.5, type: "door", width: 4 },
    ],
    office: { corner: "NW", w: 12, h: 10 },
    equipment: [
      { id: "tc", cx: 22, cy: 10, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "bal", cx: 32, cy: 10, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "comp", cx: 36, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "toolbox", cx: 20, cy: 26, rot: 0, scaleX: 1, scaleY: 1 },
    ],
  },
  {
    id: "four-bay-repair",
    name: "4-Bay General Repair",
    icon: "🔧",
    description: "Four 2-post lifts with supporting service equipment.",
    shop: { w: 60, h: 40, unit: "ft" },
    doors: [
      // One overhead door centred on each lift (lifts at x = 9/23/37/51 ft)
      { id: 1, wall: "S", pos: 0.15, type: "overhead", width: 12 },
      { id: 2, wall: "S", pos: 0.383, type: "overhead", width: 12 },
      { id: 3, wall: "S", pos: 0.617, type: "overhead", width: 12 },
      { id: 4, wall: "S", pos: 0.85, type: "overhead", width: 12 },
      { id: 5, wall: "N", pos: 0.5, type: "door", width: 4 },
    ],
    office: { corner: "NW", w: 14, h: 12 },
    equipment: [
      // Four 12 ft-wide lifts with 2 ft between them; support gear along the
      // back (north) wall so the drive-in side stays clear
      { id: "2post", cx: 9, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "2post", cx: 23, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "2post", cx: 37, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "2post", cx: 51, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "comp", cx: 55, cy: 6, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "odrain", cx: 44, cy: 6, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "toolbox", cx: 22, cy: 4, rot: 0, scaleX: 1, scaleY: 1 },   // clear of the NW office
    ],
  },
  {
    id: "alignment-bay",
    name: "Alignment Bay Setup",
    icon: "📐",
    description: "Dedicated alignment bay with tire service support.",
    shop: { w: 50, h: 35, unit: "ft" },
    doors: [
      { id: 1, wall: "S", pos: 0.35, type: "overhead", width: 12 },
      { id: 2, wall: "S", pos: 0.75, type: "overhead", width: 12 },
      { id: 3, wall: "E", pos: 0.5, type: "door", width: 4 },
    ],
    office: { corner: "NE", w: 12, h: 10 },
    equipment: [
      { id: "aln", cx: 22, cy: 18, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "tc", cx: 40, cy: 13.5, rot: 0, scaleX: 1, scaleY: 1 },   // clear of the NE office at its real 74×44" size
      { id: "bal", cx: 40, cy: 20, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "comp", cx: 46, cy: 30, rot: 0, scaleX: 1, scaleY: 1 },
    ],
  },
  {
    id: "quick-lube",
    name: "Quick Lube + Tire",
    icon: "🛢️",
    description: "Scissor lifts for quick oil changes with tire services.",
    shop: { w: 45, h: 30, unit: "ft" },
    doors: [
      { id: 1, wall: "S", pos: 0.25, type: "overhead", width: 12 },
      { id: 2, wall: "S", pos: 0.65, type: "overhead", width: 12 },
      { id: 3, wall: "N", pos: 0.5, type: "door", width: 4 },
    ],
    office: { corner: "NW", w: 10, h: 10 },
    equipment: [
      { id: "scissor", cx: 18, cy: 16, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "scissor", cx: 32, cy: 16, rot: 0, scaleX: 1, scaleY: 1 },
      { id: "odrain", cx: 10, cy: 20, rot: 0, scaleX: 1, scaleY: 1 },   // beside the lift, not on the platform
      { id: "tc", cx: 41.5, cy: 22, rot: 0, scaleX: 1, scaleY: 1 },   // clear of the scissor platform at real size
      { id: "comp", cx: 42, cy: 14, rot: 0, scaleX: 1, scaleY: 1 },
    ],
  },
];
